import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { catchError, debounceTime, distinctUntilChanged, pairwise, switchMap, tap } from 'rxjs/operators';
import { BigPropertyService } from 'src/app/components/Step 1/details2/big-property.service';
import { FormService } from '../../../shared/form.service';
import { ValidationService } from "../../../services/validation.service";
import { ProposalService } from 'src/app/shared/proposal.service';
import { TrackService } from 'src/app/services/track.service';
import { SharedService } from 'src/app/shared/shared.service';
import { FormControl, Validators } from '@angular/forms';
import * as shajs from 'sha.js';
import { LoadedFromCPService } from 'src/app/shared/loaded-from-customer-portal.service';

@Component({
  selector: 'app-details2',
  templateUrl: './details2.component.html',
  styleUrls: ['./details2.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class Details2Component implements OnInit, OnDestroy {
  parentForm;
  errorTimeout;
  movableinsuranceSumRecommended;
  immovableinsuranceSumRecommended;
  movableinsuranceSumRecommendedCurr2;
  immovableinsuranceSumRecommendedCurr2;
  checkboxes = ['movableinsuranceCheckbox', 'immovableinsuranceCheckbox'];
  hasUpdate;
  areaLast;
  subs = new Subscription();
  private isLoading = false;
  private updateBlur;
  trigger = false;
  valueMovable;
  valueImmovable;
  phoneCodes=[];
  phonePattern;
  phoneMask = '00 000 0000';
  phoneSeparator = [' '];
  deactivateMask = false;
  isValidPhone:boolean;

  constructor(private formService: FormService, private cdr: ChangeDetectorRef,
    private bigPropertyService: BigPropertyService, public validationService: ValidationService,
    public proposalService: ProposalService,
    public trackService: TrackService,
    private loadedFromCPService: LoadedFromCPService,
    public sharedService: SharedService) {
  }

  get firstCountryCode() {
    return this.parentForm.get('firstCountryCode');
  }
  get firstPhoneNumber() {
    return  this.parentForm.get('firstPhoneNumber');
  }

  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  readMore() {
    this.trigger = !this.trigger;
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0 });
    this.parentForm = this.formService.currentForm;
    // if (this.parentForm.getRawValue().movableinsuranceCheckbox < this.parentForm.getRawValue().movableinsuranceSum) {
    //   this.parentForm.controls.movableinsuranceSumRecommended.setValue(this.parentForm.getRawValue().movableinsuranceSum);
    //   this.valueMovable = this.parentForm.getRawValue().movableinsuranceSum;
    // }
    // if (this.parentForm.getRawValue().immovableinsuranceCheckbox < this.parentForm.getRawValue().immovableinsuranceSum) {
    //   this.parentForm.controls.immovableinsuranceSumRecommended.setValue(this.parentForm.getRawValue().immovableinsuranceSum);
    //   this.valueMovable = this.parentForm.getRawValue().movableinsuranceSum;
    // }
    if(this.parentForm.getRawValue().movableinsuranceSumRecommended){
      this.movableinsuranceSumRecommended = this.parentForm.getRawValue().movableinsuranceSum;
    }
    if(this.parentForm.getRawValue().immovableinsuranceSumRecommended){
      this.immovableinsuranceSumRecommended = this.parentForm.getRawValue().immovableinsuranceSum;
    }

  this.isValidPhone=true;

    setTimeout(() => {
      this.parentForm.controls.errorControl.setErrors(null);
    }, 200)
    this.parentForm.controls.immovableinsuranceCheckbox.disable();
    this.parentForm.controls.movableinsuranceCheckbox.disable();
    if (this.parentForm.getRawValue().immovableinsuranceSumRecommended) {
      this.parentForm.controls.immovableinsuranceCheckbox.enable();
    }
    if (this.parentForm.getRawValue().movableinsuranceSumRecommended) {
      this.parentForm.controls.movableinsuranceCheckbox.enable();
    }
    this.parentForm.controls.immovableinsuranceSumRecommended.disable();
    this.parentForm.controls.movableinsuranceSumRecommended.disable();
    this.validationService.registerControl(this.parentForm.controls.errorControl);
    this.sharedService.getPhoneCodes().subscribe();

    this.parentForm.controls['firstPhoneNumber'].valueChanges.subscribe(value => {
      // console.log( this.parentForm.controls['firstPhoneNumber'])
      // //this.parentForm.get('firstPhoneNumber').setValidators(Validators.required)
      // if(!value){
      //   this.parentForm.get('firstPhoneNumber').setErrors({error:true});
      // }
      // else{
      //   this.parentForm.get('firstPhoneNumber').setErrors(null);
      // }
      this.proposalService.setPhoneNumber(this.parentForm.get('firstCountryCode').value, value );
    });

    this.subs.add(this.parentForm.controls.area.valueChanges
      .pipe(
        catchError(err => of(err)),
        debounceTime(300),
        distinctUntilChanged(),
        pairwise(),
        filter(([oldValue, changed]) => {
          if (changed && changed >= 1 && changed <= 500) {
            this.parentForm.controls.immovableinsuranceCheckbox.enable();
            this.parentForm.controls.movableinsuranceCheckbox.enable();
            this.parentForm.updateValueAndValidity();
            return true;
          } else {
            this.parentForm.controls.immovableinsuranceCheckbox.disable();
            this.parentForm.controls.movableinsuranceCheckbox.disable();
            this.parentForm.controls.area.setErrors({ invalid: true });
            this.parentForm.updateValueAndValidity();
            return false
          }
        })
      ))


    const fields = ['movableinsuranceSumRecommended', 'immovableinsuranceSumRecommended'];
    fields.forEach((item, index) => {
      this.subs.add(this.parentForm.controls[item].valueChanges
        .pipe(
          tap(() => {
            if (this.parentForm.controls[item].enabled) {
              this.parentForm.controls.errorControl.setErrors({ invalid: true });
            }
            this.isLoading = true;
          }),
          debounceTime(300),
          distinctUntilChanged(),
          switchMap(term => {


            if (term < this.parentForm.getRawValue().movableinsuranceSum) {
              this.parentForm.controls.immovableinsuranceCheckbox.enable();
              this.parentForm.controls.movableinsuranceCheckbox.enable();
              term = this.parentForm.getRawValue().movableinsuranceSum;
            }
            if (item === 'immovableinsuranceSumRecommended' && term && this.parentForm.controls.immovableinsuranceSumRecommended.enabled) {
              // this.parentForm.controls.errorControl.setErrors({invalid: true});
              const {
                propertyCategory,
                propertySubcategory,
                currency,
                immovableinsuranceSumRecommended
              } = this.parentForm.getRawValue();
              const mData = {
                propertyCategory: propertyCategory,
                propertySubcategory: propertySubcategory,
                currency: currency,
                immovableinsuranceSum: immovableinsuranceSumRecommended
              }
              return this.bigPropertyService.getInsSumsMovable(mData).pipe(switchMap((s: any) => {
                this.movableinsuranceSumRecommended = s.immovableinsuranceSum;

                this.parentForm.patchValue({
                  immovableinsuranceSum: s.immovableinsuranceSum,
                  movableinsuranceSum: s.movableinsuranceSum,
                  movableinsuranceSumRecommended: s.movableinsuranceSumRecommended,
                });
                this.parentForm.updateValueAndValidity();
                return this.bigPropertyService.calculatePremiums()
                  .pipe(
                    catchError(err => {
                      setTimeout(() => {
                        this.parentForm.get('immovableinsuranceSumRecommended').setErrors({ invalid: err.error.sErr_Text });
                      })
                      this.parentForm.controls[this.checkboxes[index]].disable();
                      this.parentForm.controls['immovableinsuranceSumRecommended'].enable();
                      this.parentForm.updateValueAndValidity();
                      return of(null);
                    })
                  );
              }));
            }
            if (term && this.parentForm.controls[item].enabled) {
              // this.parentForm.controls.errorControl.setErrors({invalid: true});
              return this.bigPropertyService.calculatePremiums()
                .pipe(
                  catchError(err => {
                    setTimeout(() => {
                      this.parentForm.controls[item].setErrors({ invalid: err.error.sErr_Text });
                    });
                    this.parentForm.controls[this.checkboxes[index]].disable();
                    this.parentForm.controls[item].enable();
                    this.parentForm.updateValueAndValidity();
                    return of(null);
                  })
                );
            } else {
              return of(null);
            }
          }
          ),
        ).subscribe(x => {
          if (this.errorTimeout) {
            clearTimeout(this.errorTimeout);
          }
          this.errorTimeout = setTimeout(() => {
            this.parentForm.controls.errorControl.setErrors(null);
          }, 300)
          this.isLoading = false;
          if (this.updateBlur) {
            this.updateBlur = null;
          }
          if (x) {
            this.parentForm.controls[item].setErrors(null);
            // this.parentForm.controls[item].setErrors({required: true});
            this.parentForm.controls[this.checkboxes[index]].enable();
          }
          this.validationService.registerControl(this.parentForm.controls[item])
        }))
    })
  }

  setArea(){
      this.bigPropertyService.howBig(this.parentForm.controls.area.value)
          .pipe(
            catchError(err => {
              this.parentForm.controls.area.setErrors({ invalid: err.error.sErr_Text });
              this.sharedService.loadingSpinner = false;
              // this.parentForm.updateValueAndValidity();
              return of(null);
            })
          )
      .subscribe(x => {
        if (x) {
          this.parentForm.controls.immovableinsuranceCheckbox.enable();
          this.parentForm.controls.movableinsuranceCheckbox.enable();
          this.parentForm.controls.immovableinsuranceSumRecommended.setValue(x.immovableinsuranceSumRecommended);
          this.parentForm.controls.movableinsuranceSumRecommended.setValue(x.movableinsuranceSumRecommended);
          this.parentForm.controls.immovableinsuranceSumRecommendedCurr2.setValue(x.immovableinsuranceSumRecommendedCurr2);
          this.parentForm.controls.movableinsuranceSumRecommendedCurr2.setValue(x.movableinsuranceSumRecommendedCurr2);
          this.immovableinsuranceSumRecommended = x.immovableinsuranceSum;
          this.movableinsuranceSumRecommended = x.immovableinsuranceSumRecommended;
          this.immovableinsuranceSumRecommendedCurr2 = x.immovableinsuranceSumCurr2;
          this.movableinsuranceSumRecommendedCurr2 = x.immovableinsuranceSumRecommendedCurr2;
          this.parentForm.controls.immovableinsuranceSum.setValue(x.immovableinsuranceSum);
          this.parentForm.controls.movableinsuranceSum.setValue(x.movableinsuranceSum);
        } else {
          this.parentForm.controls.area.setErrors({ invalid: true });
          this.parentForm.controls.immovableinsuranceSum.setValue(null);
          this.parentForm.controls.immovableinsuranceSumRecommended.setValue(null);
          this.parentForm.controls.immovableinsuranceSumRecommendedCurr2.setValue(null);
          this.parentForm.controls.movableinsuranceSum.setValue(null);
          this.parentForm.controls.movableinsuranceSumRecommended.setValue(null);
          this.parentForm.controls.movableinsuranceSumRecommendedCurr2.setValue(null);
          this.parentForm.controls.immovableinsuranceCheckbox.disable();
          this.parentForm.controls.movableinsuranceCheckbox.disable();
          this.immovableinsuranceSumRecommended = null;
          this.movableinsuranceSumRecommended = null;
          this.immovableinsuranceSumRecommendedCurr2 = null;
          this.movableinsuranceSumRecommendedCurr2 = null;
          this.parentForm.updateValueAndValidity();
        }
        this.sharedService.loadingSpinner = false;

      }
      );
  }


  enableImmovableinsuranceSum() {
    this.parentForm.controls.immovableinsuranceSum.enable();
  }

  setCheckbox(value, controlName, checkBoxName, currentName, event) {
    event.stopPropagation();
    event.cancelBubble = true;
    event.preventDefault();
    const x = (that) => {

      return (function() {
        const getControl = that.formService.currentForm.get(currentName);
        //!that.isLoading &&
        if (that.formService.currentForm.get(controlName).valid) {
          getControl.setValue(value, { onlySelf: true, emitEvent: true, emitModelToViewChange: true });
          getControl.disable();
          that.onCheckedChange(value, controlName, checkBoxName);

        }
      })()
    }

    this.updateBlur = x(this);
    if (!this.isLoading) {
      this.updateBlur = null;
    }
  }

  onCheckedChange(isCheck: boolean, controlName: string, checkBoxName) {
    //example movableinsuranceSumRecommended = controlName
    const getControl = this.formService.currentForm.get(controlName);


    const controls = ['area', 'claimsExists'];
    controls.forEach(item => {
      if (isCheck) {

        this.parentForm.controls.errorControl.setErrors({ invalid: true });
        this.formService.currentForm.get(item).disable();
        this.formService.currentForm.get(checkBoxName).disable();

        setTimeout(() => {
          this.formService.currentForm.get(controlName).nativeElement.focus()
        }, 0)


        getControl.enable();
        // getControl.setErrors({required: true})
        this.validationService.registerControl(getControl);
      } else {
        this.parentForm.controls.errorControl.setErrors(null);
        this.parentForm.controls[item].markAsUntouched();
        this.parentForm.controls[item].markAsPristine();
        this.formService.currentForm.get(item).enable();
        this.formService.currentForm.get('movableinsuranceCheckbox').enable();
        getControl.disable();
        this.formService.currentForm.get('immovableinsuranceCheckbox').enable();

      }
    });

    if (controlName == "movableinsuranceSumRecommended") {

      if (getControl.value < this.parentForm.controls.movableinsuranceSum.value) {

        this.parentForm.controls.immovableinsuranceCheckbox.enable();
        this.parentForm.controls.movableinsuranceCheckbox.enable();
      }
    }
    if (controlName == "immovableinsuranceSumRecommended") {

      if (getControl.value < this.parentForm.controls.immovableinsuranceSum.value) {

        this.parentForm.controls.immovableinsuranceCheckbox.enable();
        this.parentForm.controls.movableinsuranceCheckbox.enable();
      }
    }

  }




  setDigitalDataArea(value) {
    if (value && (this.areaLast != value)) {
      // window['qbhome'].push({
      //   'process': {
      //     'name': 'propertyDetails.squareMeters',
      //     'value': value,
      //     'type': 'once',
      //     'mode': 'add/remove'
      //   }
      // });
    }
    this.areaLast = value;
    //console.log(window['digitalData']);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
